import { Buffer } from "buffer";
import blake2b from "blake2b";

export const blake = {
  hash32: (data: Buffer): Buffer => {
    return Buffer.from(blake2b(32).update(Uint8Array.from(data)).digest());
  },
  hash28: (data: Buffer): Buffer => {
    return Buffer.from(blake2b(28).update(Uint8Array.from(data)).digest());
  },
  uint8Array:{
    hash32: (data: Uint8Array): Uint8Array => {
      return blake2b(32).update(data).digest();
    },
    hash28: (data: Uint8Array): Uint8Array => {
      return blake2b(28).update(data).digest();
    }
  }
};
